import { useMemo } from 'react'
import { useApi } from '../../../utils'
import {
    SearchDeviceConfigQuerySchema,
    SearchDeviceConfigVariablesSchema,
    type SearchDeviceConfigVariables
} from '../searchConfig_schemas'

export const useSearchDeviceConfig = (path: string[] | undefined, value: string | undefined) => {
    const variables = useMemo<SearchDeviceConfigVariables | undefined>(
        () => (path && value ? SearchDeviceConfigVariablesSchema.parse({ path, value }) : undefined),
        [path, value]
    )

    const result = useApi('/platform/get_devices_by_config', variables, SearchDeviceConfigQuerySchema, {
        queryKey: ['platform/get_devices_by_config', variables],
        enabled: !!variables
    })

    return { data: result.data, loading: result.isFetching, error: result.error }
}
